import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import DatagridPremiumUi from '../../Interface/DatagridPremmium/DataGridPremiumUI';
import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers } from '../../Interface/Datagrid/DataGridIdentifiers';
import RecognizeItemButton from '../Components/RecognizeItemButton';

const DeliveryBaseDocTab = ({ baseDocLines, onRecognizeItem }) => {
  const columns = useMemo(
    () =>
      dataGridPremiumColumns([
        {
          field: 'itemCode',
          headerName: 'Cikk',
          flex: 1,
          renderCell: (params) => {
            const itemCode = params.row?.itemCode ?? '';
            const itemName = params.row?.itemName ?? params.row?.item?.itemName ?? '';
            return (
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <Box component="span" sx={{ fontWeight: 700 }}>
                  {itemCode}
                </Box>
                {itemName ? ` - ${itemName}` : ''}
              </Typography>
            );
          },
        },
        {
          field: 'qntQty',
          headerName: 'QNT',
          flex: 0.4,
          renderCell: (params) => {
            const openQty = Number(params.row?.qntQty ?? 0) || 0;
            const quantityUnitCode =
              params.row?.uom ?? params.row?.quantityUnitCode ?? params.row?.quantityUnit?.code ?? '';
            return `${openQty} ${quantityUnitCode}`.trim();
          },
        },
        {
          field: 'wmsQty',
          headerName: 'WMS',
          flex: 0.4,
          renderCell: (params) => {
            const quantityUnitCode =
              params.row?.uom ?? params.row?.quantityUnitCode ?? params.row?.quantityUnit?.code ?? '';
            const wmsQty = Number(params.row?.wmsQty ?? 0) || 0;
            const qtyDiff = Number(params.row?.qtyDiff ?? 0) || 0;
            const color = qtyDiff > 0 ? 'error.dark' : qtyDiff === 0 ? 'success.main' : 'info.main';

            return (
              <Typography variant="body2" sx={{ color, fontWeight: 600 }}>
                {`${wmsQty} ${quantityUnitCode}`.trim()}
              </Typography>
            );
          },
        },
        {
          field: 'actions',
          headerName: '',
          flex: 0.2,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          renderCell: (params) => (
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}
            >
              <RecognizeItemButton onClick={() => onRecognizeItem(params.row)} />
            </Box>
          ),
        },
      ]),
    [onRecognizeItem]
  );

  return (
    <Box sx={{ pb: 1, pt: 3, width: '100%' }}>
      <DatagridPremiumUi
        datagridIdentifier={DataGridIdentifiers.wmsDeliveryBaseDocLines}
        rows={baseDocLines ?? []}
        columns={columns}
        loading={false}
        sx={{ width: '100%' }}
        pagination={false}
        disableRowSelectionOnClick
        headerFilters={false}
        getRowHeight={() => 'auto'}
        getRowId={(row) =>
          `${row?.baseDocId ?? row?.docId ?? 'base'}-${row?.lineNum ?? row?.id ?? row?.itemCode ?? ''}`
        }
        slots={{
          toolbar: null,
        }}
      />
    </Box>
  );
};

export default DeliveryBaseDocTab;
